<template>
  <div class="landing">
    <!-- Header -->
    <header class="header">
      <div class="logo-container">
        <img src="@/assets/logo_ziel.png" alt="Ziel Logo" class="logo" />
        <h1 class="title">Ziel</h1>
      </div>
    </header>

    <!-- Intro Section -->
    <section class="section">
      <div class="text">
        <h2>Your Eisstocksport App <br> Anytime, Anywhere.</h2>
        <br>
        <p>
          Keep track of every match, analyze your performance, and take your
          game to the next level. Ziel is built for players who want precision,
          history, and progress right in their hands.
        </p>
      </div>
      <div class="image">
        <img src="@/assets/1.png" alt="Generic intro image" />
        <img src="@/assets/7.png" alt="Generic intro image" />
      </div>
    </section>

    <!-- Register Games Section -->
    <section class="section reverse">
      <div class="text">
        <h2>Never lose track of a single throw.</h2>
        <p>
          Easily record game dates, locations, and every round’s score. Ziel
          saves your results securely and organizes them into clear tables and
          charts – ready to review whenever you need.
        </p>
      </div>
      <div class="image">
        <img src="@/assets/3.png" alt="Generic intro image" />
        <img src="@/assets/8.png" alt="Generic intro image" />
      </div>
    </section>

    <!-- Premium Section -->
    <section class="section">
      <div class="text">
        <h2>Unlock the full potential of Ziel.</h2>
        <p>
          Get advanced insights, personalized statistics, and PDF/CSV export
          options. With premium, you’ll have everything you need to study your
          performance and share results with your team or club.
        </p>
      </div>
      <div class="image">
        <img src="@/assets/4.png" alt="Generic intro image" />
        <img src="@/assets/6.png" alt="Generic intro image" />
      </div>
    </section>

    <!-- About the Creator -->
    <section class="about">
      <div class="photo">
        <img src="@/assets/guto-bg.jpg" alt="Guto - Creator of Ziel" />
      </div>
      <div class="text">
        <h2>About the Creator</h2>
        <p>
          Hi, I’m Augusto Böhm – civil engineer, project manager, and Eisstocksport
          athlete. I created Ziel to give players the tools I always wanted:
          precise score tracking, detailed stats, and a way to share results
          with the community. Ziel is built by a player, for players.
        </p>
      </div>

    </section>

    <!-- Call to Action -->
    <section class="cta">
      <a class="store-btn" href="https://play.google.com/store/apps/details?id=com.augustobohm.ziel&pcampaignid=web_share" target="_blank"
        rel="noopener">
        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt="Get it on Play Store" />
      </a>
      <a class="store-btn" href="https://apps.apple.com/us/app/ziel-app/id6756295929" target="_blank"
        rel="noopener">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/2560px-Download_on_the_App_Store_Badge.svg.png"
          alt="Get it on Apple Store" />
      </a>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <router-link to="/DeleteAccount">Delete Account</router-link>
      <router-link to="/PrivacyPolicy">Privacy Policy</router-link>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  background: linear-gradient(45deg, #35080a, #151b28);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

.landing {
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  background: linear-gradient(45deg, #35080a, #151b28);
  color: white;
  font-family: "Arial", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  text-align: center;
  padding: 2rem;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.logo {
  width: 160px;
  height: 160px;
}

.title {
  font-size: 6rem;
  font-weight: bold;
}

.tagline {
  margin-top: 1rem;
  font-size: 1.5rem;
  opacity: 0.9;
}

.section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 10%;
  gap: 2rem;
}

.section.reverse {
  flex-direction: row-reverse;
}

.section .text {
  flex: 1;
}

.section .text h2 {
  font-size: 2.8rem;
  margin-bottom: 1rem;
}

.section .text p {
  font-size: 1.5rem;
  line-height: 1.6;
}

.section .image {
  flex: 1;
  display: flex;
  justify-content: center;
}

.section .image img {
  max-width: 100%;
  border-radius: 10px;
  height: 500px;
}

.about {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 10%;
  gap: 5rem;
  background: rgba(0, 0, 0, 0.6);
  /* mantém contraste com o resto da página */
}

.about .text {
  flex: 1;
  max-width: 600px;
}

.about .text h2 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
}

.about .text p {
  font-size: 1.5rem;
  line-height: 1.6;
}

.about .photo {
  flex: 1;
  display: flex;
  justify-content: center;
  height: 500px;
}

.about .photo img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  object-fit: cover;
}

.overlay {
  background: rgba(0, 0, 0, 0.6);
  padding: 1rem;
  border-radius: 10px;
  text-align: center;
  max-width: 600px;
}

.overlay h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.overlay p {
  font-size: 1.2rem;
  line-height: 1.6;
}

.cta {
  text-align: center;
}

.store-btn img {
  width: 200px;
  transition: transform 0.2s ease;
  margin: 3rem;
}

.store-btn img:hover {
  transform: scale(1.05);
}

.footer {
  text-align: center;
  padding: 2rem;
}

.footer a {
  color: white;
  text-decoration: underline;
  padding: 1rem;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .landing {
    font-size: 90%;
  }

  .header {
    padding: 1.5rem;
  }

  .logo {
    width: 100px;
    height: 100px;
  }

  .title {
    font-size: 3rem;
  }

  .section {
    flex-direction: column;
    text-align: center;
    padding: 2rem 5%;
  }

  .section.reverse {
    flex-direction: column;
  }

  .section .text h2 {
    font-size: 2rem;
  }

  .section .text p {
    font-size: 1.1rem;
  }

  .section .image {
    flex-direction: column;
  }

  .section .image img {
    height: auto;
    width: 90%;
    margin-bottom: 1rem;
  }

  .about {
    flex-direction: column;
    text-align: center;
    padding: 2rem 5%;
  }

  .about .photo {
    height: auto;
  }

  .about .text h2 {
    font-size: 2.2rem;
  }

  .about .text p {
    font-size: 1.1rem;
  }

  .cta {
        padding: 10rem;
    margin: 2rem;
  }

    .cta img{
    padding: 10rem;
    margin: 4rem;
  }

  .store-btn img {
    width: 160px;
  }

  .footer {
    padding: 8rem;
  }

  .footer a {
    display: block;
    padding: 0.5rem 0;
    font-size: 0.8rem;
  }
}

/* ================= TABLETS (769px a 1024px) ================= */
@media (max-width: 1024px) and (min-width: 769px) {
  .section {
    padding: 3rem 8%;
  }

  .section .text h2 {
    font-size: 2.4rem;
  }

  .section .text p {
    font-size: 1.3rem;
  }

  .about .text h2 {
    font-size: 2.8rem;
  }
}
</style>
